<script setup lang="ts">
import ApostatudoGames from '~/components/casino/games/ApostatudoGames.vue';
import { scrollToTop } from '~/utils/scroll';

const { isDesktop } = useLayout();

onMounted(() => {
  if (isDesktop.value) return;

  // Abre a página já scrollada o suficiente pra esconder o menu horizontal
  // (#divMenuHighlight) e mostrar o filtro direto. No main o scroller é a
  // window e o scrollBehavior padrão do Nuxt reseta pro topo logo após o
  // mount, cancelando um scroll suave. Por isso reaplicamos de forma instant
  // por alguns frames + um reforço com timeout, vencendo esse reset tardio.
  const apply = () => {
    const el = document.getElementById('divMenuHighlight');

    if (el) scrollToTop(el.offsetHeight, false);
  };

  requestAnimationFrame(() => {
    apply();
    requestAnimationFrame(apply);
  });

  setTimeout(apply, 150);
});
</script>

<template>
  <ApostatudoGames />
</template>
